import type {
  ScholarshipEducationLevel,
  ScholarshipDocumentSlot,
} from './types';

export const EGYPTIAN_GOVERNORATES: { value: string; label: string }[] = [
  { value: 'cairo', label: 'القاهرة' },
  { value: 'giza', label: 'الجيزة' },
  { value: 'alexandria', label: 'الإسكندرية' },
  { value: 'qalyubia', label: 'القليوبية' },
  { value: 'sharqia', label: 'الشرقية' },
  { value: 'dakahlia', label: 'الدقهلية' },
  { value: 'beheira', label: 'البحيرة' },
  { value: 'gharbia', label: 'الغربية' },
  { value: 'monufia', label: 'المنوفية' },
  { value: 'kafr_el_sheikh', label: 'كفر الشيخ' },
  { value: 'damietta', label: 'دمياط' },
  { value: 'port_said', label: 'بورسعيد' },
  { value: 'ismailia', label: 'الإسماعيلية' },
  { value: 'suez', label: 'السويس' },
  { value: 'north_sinai', label: 'شمال سيناء' },
  { value: 'south_sinai', label: 'جنوب سيناء' },
  { value: 'beni_suef', label: 'بني سويف' },
  { value: 'faiyum', label: 'الفيوم' },
  { value: 'minya', label: 'المنيا' },
  { value: 'asyut', label: 'أسيوط' },
  { value: 'sohag', label: 'سوهاج' },
  { value: 'qena', label: 'قنا' },
  { value: 'luxor', label: 'الأقصر' },
  { value: 'aswan', label: 'أسوان' },
  { value: 'red_sea', label: 'البحر الأحمر' },
  { value: 'new_valley', label: 'الوادي الجديد' },
  { value: 'matrouh', label: 'مطروح' },
];

export const GOVERNORATE_LABELS: Record<string, string> = Object.fromEntries(
  EGYPTIAN_GOVERNORATES.map((g) => [g.value, g.label])
);

export const EDUCATION_LEVELS: { value: ScholarshipEducationLevel; label: string }[] = [
  { value: 'high_school_student', label: 'طالب ثانوية' },
  { value: 'high_school_graduate', label: 'حاصل على الثانوية' },
  { value: 'university_student', label: 'طالب جامعة' },
  { value: 'university_graduate', label: 'خريج جامعة' },
];

export const EDUCATION_LEVEL_LABELS: Record<ScholarshipEducationLevel, string> = {
  high_school_student: 'طالب ثانوية',
  high_school_graduate: 'حاصل على الثانوية',
  university_student: 'طالب جامعة',
  university_graduate: 'خريج جامعة',
};

export const DOCUMENT_SLOTS: {
  slot: ScholarshipDocumentSlot;
  label: string;
}[] = [
  {
    slot: 'academic_certificate',
    label: 'شهادة الثانوية أو شهادة التخرج',
  },
  {
    slot: 'national_id_front',
    label: 'صورة البطاقة — الوجه الأمامي',
  },
  {
    slot: 'national_id_back',
    label: 'صورة البطاقة — الوجه الخلفي',
  },
];

export const DOCUMENT_SLOT_LABELS: Record<ScholarshipDocumentSlot, string> = {
  academic_certificate: 'شهادة الثانوية أو شهادة التخرج',
  national_id_front: 'صورة البطاقة — الوجه الأمامي',
  national_id_back: 'صورة البطاقة — الوجه الخلفي',
};

export const STEP_NAMES = ['بياناتك', 'الدراسة', 'المستندات', 'مراجعة'] as const;

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB
export const MIN_FILE_SIZE = 1024; // 1 KB

export const ALLOWED_FILE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'] as const;
export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
] as const;
